import React from "react";
import { Box } from "@mui/material";
import SupportContactDialog from "../../components/SupportContactDialog";
import useFirstTimeRegister from "./hooks/useFirstTimeRegister";
import RegisterHeroColumn from "./components/RegisterHeroColumn";
import RegisterFormColumn from "./components/RegisterFormColumn";
import RegisterLawFirmCreationDialog from "./components/RegisterLawFirmCreationDialog";
import RegisterFuzzyMatchDialog from "./components/RegisterFuzzyMatchDialog";
import RegisterBottomTabs from "./components/RegisterBottomTabs";
import RegisterPremiumCalculatorDialog from "./components/RegisterPremiumCalculatorDialog";

const FirstTimeRegister = () => {
  const p = useFirstTimeRegister();

  return (
    <Box
      display="flex"
      flexDirection="row"
      height="100vh"
      data-testid="register-page"
      data-register-variant="firstTimeRegister"
      sx={{
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Left Column - Hero Section */}
      <RegisterHeroColumn isMobile={p.isMobile} />

      {/* Right Column - Registration Form */}
      <Box
        sx={{
          width: p.isMobile ? "100%" : "40%",
          display: "flex",
          paddingTop: "2vh",
          paddingBottom: "140px",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "#fafafa",
          position: "relative",
          height: "100%",
          overflowY: "auto",
          background: p.isMobile
            ? "white"
            : "linear-gradient(135deg, #fafafa 0%, #f0f0f0 100%)",
          "&::before": p.isMobile
            ? {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "transparent",
              pointerEvents: "none",
            }
            : {},
        }}
      >
        <RegisterFormColumn p={p} />
      </Box>

      <RegisterLawFirmCreationDialog p={p} />

      <RegisterFuzzyMatchDialog p={p} />

      {/* Calculator Tab at Bottom */}
      <RegisterBottomTabs p={p} />

      <SupportContactDialog
        open={p.openSupport}
        onClose={p.handleCloseSupport}
        context="First Time Register"
      />

      {/* Calculator Dialog */}
      <RegisterPremiumCalculatorDialog p={p} />

      {/* CSS Animations */}
      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
      `}</style>
    </Box>
  );
};

export default FirstTimeRegister;
